import React from "react";
import { Check } from "lucide-react";
import "./CustomToggle.scss";

export function CustomToggle({ checked, onCheckedChange, id, disabled }) {
  return (
    <button
      type="button"
      role="switch"
      id={id}
      disabled={disabled}
      aria-checked={checked}
      onClick={() => !disabled && onCheckedChange(!checked)}
      className={`custom-toggle ${checked ? "is-checked" : ""} ${disabled ? "is-disabled" : ""}`}
    >
      <span className={`custom-toggle__knob ${checked ? "is-checked" : ""}`}>
        {checked && <Check className="custom-toggle__icon" />}
      </span>
    </button>
  );
}